export default {
  orders: {},
  ticketsInventory: [],
  ordersEventDoughnutChart: []
}